import { render, staticRenderFns } from "./PriceTemplateCreate.vue?vue&type=template&id=06bc8c52"
import script from "./PriceTemplateCreate.vue?vue&type=script&lang=ts"
export * from "./PriceTemplateCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports